// @flow

import * as React from 'react';
import { Breadcrumb, Divider } from 'antd';
import { NavLink } from 'react-router-dom';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import { getTeamUrl } from 'Common'

type Props = {
  order: any,
  sidebarOpen?: boolean,
  onToggleSidebar?: Function
}

export default (props: Props) => {

  const { order, sidebarOpen, onToggleSidebar } = props;

  return (

    <React.Fragment>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Breadcrumb separator="»">

        <Breadcrumb.Item>
          Home
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          <NavLink to={getTeamUrl("orders")}>
            Orders
          </NavLink>
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          {order.reference}
        </Breadcrumb.Item>

      </Breadcrumb>

        {onToggleSidebar && (
          <button
            onClick={onToggleSidebar}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px 8px',
              fontSize: '20px',
              color: '#1890ff',
              display: 'none',
            }}
            className="mobile-sidebar-toggle-btn"
            aria-label="Toggle sidebar"
          >
            {sidebarOpen ? <CloseOutlined /> : <MenuOutlined />}
          </button>
        )}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .mobile-sidebar-toggle-btn {
            display: inline-block !important;
          }
        }
      `}</style>

      <Divider />

    </React.Fragment>

  )
}
